import baseApi from './base';

const fetchAll = () =>
  baseApi.request({
    method: 'get',
    url: '/categories'
  })

const fetchOne = id =>
  baseApi.request({
    method: 'get',
    url: `/categories/${id}`
  })

const modifyOne = data =>
  baseApi.request({
    method: 'patch',
    url: `/categories/${data.id}`,
    data
  })

const modifyTrees = data =>
  baseApi.request({
    method: 'patch',
    url: '/categories/trees',
    data
  })

const createOne = data =>
  baseApi.request({
    method: 'post',
    url: '/categories',
    data
  })

const deleteAll = data =>
  baseApi.request({
    method: 'delete',
    url: '/categories',
    data
  })

const downloadCategoryTemplate = () =>
  baseApi.request({
    method: 'get',
    url: '/categories/download-template',
    responseType: 'blob'
  });

const uploadCategories = data =>
  baseApi.request({
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    method: 'post',
    url: '/categories/upload',
    responseType: 'blob',
    data
  });

export {
  fetchAll,
  fetchOne,
  modifyOne,
  modifyTrees,
  createOne,
  deleteAll,
  downloadCategoryTemplate,
  uploadCategories
}


// WEBPACK FOOTER //
// ./src/api/category.js